var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.178 3.421H5.822C4.263 3.421 3 4.591 3 6.034v14.353C3 21.83 4.263 23 5.822 23h12.356C19.737 23 21 21.83 21 20.387V6.034c0-1.443-1.263-2.613-2.822-2.613z",
    stroke: "#B9BBC6",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.602 14.872H7.886c-.87 0-1.575.653-1.575 1.458v2.515c0 .805.705 1.458 1.575 1.458h2.716c.87 0 1.575-.653 1.575-1.458V16.33c0-.805-.705-1.458-1.575-1.458z",
    stroke: "#B9BBC6",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 8.735l2.726 2.73 3.256-4.852M7.129 1h9.742M17.744 6.627V19.79",
    stroke: "#B9BBC6",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgPlayIcon;